type PricingGroup = {
  freeLimit: number;
  items: {
    id: number;
    sortOrder?: number;
    priceWithinFreeLimit: number;
    priceAfterFreeLimit: number;
    childGroups: PricingGroup[];
  }[];
};

export type OptionSelection = { itemId: number; selectedQuantity: number; selectionSort: number };

export function priceAndBuild(
  groups: PricingGroup[], selected: Record<number, number>, pickOrder?: number[],
): { extra: number; selections: OptionSelection[]; itemExtras: Record<number, number> } {
  let extra = 0;
  let sort = 0;
  const selections: OptionSelection[] = [];
  const itemExtras: Record<number, number> = {};
  const rank = (id: number): number => {
    if (!pickOrder) return Number.MAX_SAFE_INTEGER;
    const index = pickOrder.indexOf(id);
    return index >= 0 ? index : Number.MAX_SAFE_INTEGER;
  };
  const walk = (group: PricingGroup): void => {
    const picks = group.items.filter((item) => (selected[item.id] ?? 0) > 0)
      .sort((first, second) => rank(first.id) - rank(second.id) || (first.sortOrder ?? 0) - (second.sortOrder ?? 0) || first.id - second.id);
    let pickIndex = 0;
    for (const item of picks) {
      const quantity = selected[item.id] ?? 0;
      let rowExtra = 0;
      for (let unit = 0; unit < quantity; unit += 1) {
        pickIndex += 1;
        rowExtra += pickIndex <= group.freeLimit ? item.priceWithinFreeLimit : item.priceAfterFreeLimit;
      }
      extra += rowExtra;
      itemExtras[item.id] = Math.round(rowExtra * 100) / 100;
      selections.push({ itemId: item.id, selectedQuantity: quantity, selectionSort: sort });
      sort += 1;
      item.childGroups.forEach(walk);
    }
  };
  groups.forEach(walk);
  return { extra: Math.round(extra * 100) / 100, selections, itemExtras };
}